import { type PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export const ContentWrapper = ({ children }: PropsWithChildren) => {
  return (
    <main className={cn('px-[20px] pb-0 pt-[40px]', 'mx-auto mb-[70px] mt-0', 'max-w-[1144px]', 'min-h-full')}>
      {children}
    </main>
  )
}
